module.exports = __webpack_public_path__ + "static/media/huawei_app_launch_1.199e6534.png";